var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "303B3024-2B7D-4758-A90F-EBDAA64723EF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-273.000000, -1658.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container",
    transform: "translate(273.000000, 1658.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-64",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 104,
    height: 66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(13.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L77,0 C77.5522847,-1.01453063e-16 78,0.44771525 78,1 L78,34 C78,34.5522847 77.5522847,35 77,35 L1,35 C0.44771525,35 6.76353751e-17,34.5522847 0,34 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle",
    stroke: "#BBBBBD",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 2.37804878,
    x2: 26.5,
    y2: 32.6219512,
    id: "Line-10",
    stroke: "#BBBBBD",
    strokeWidth: 0.8,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 2.37804878,
    x2: 52.5,
    y2: 32.6219512,
    id: "Line-10-Copy",
    stroke: "#BBBBBD",
    strokeWidth: 0.8,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8181818,23.6666667 L21.8181818,26 C21.8181818,26.5522847 21.3704666,27 20.8181818,27 L6,27 C5.44771525,27 5,26.5522847 5,26 L5,23.6666667 L5,23.6666667 L21.8181818,23.6666667 Z",
    id: "Shape-Copy-2",
    fill: "#BBBBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8181818,23.6666667 L47.8181818,26 C47.8181818,26.5522847 47.3704666,27 46.8181818,27 L32,27 C31.4477153,27 31,26.5522847 31,26 L31,23.6666667 L31,23.6666667 L47.8181818,23.6666667 Z",
    id: "Shape-Copy-12",
    fill: "#BBBBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8181818,23.6666667 L73.8181818,26 C73.8181818,26.5522847 73.3704666,27 72.8181818,27 L58,27 C57.4477153,27 57,26.5522847 57,26 L57,23.6666667 L57,23.6666667 L73.8181818,23.6666667 Z",
    id: "Shape-Copy-13",
    fill: "#BBBBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,7 L20.15,7 C20.9784271,7 21.65,7.67157288 21.65,8.5 L21.65,22 L21.65,22 L5,22 L5,8.5 C5,7.67157288 5.67157288,7 6.5,7 Z",
    id: "Rectangle-Copy-34",
    fill: "#BBBBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,7 L46.15,7 C46.9784271,7 47.65,7.67157288 47.65,8.5 L47.65,22 L47.65,22 L31,22 L31,8.5 C31,7.67157288 31.6715729,7 32.5,7 Z",
    id: "Rectangle-Copy-98",
    fill: "#BBBBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,7 L72.15,7 C72.9784271,7 73.65,7.67157288 73.65,8.5 L73.65,22 L73.65,22 L57,22 L57,8.5 C57,7.67157288 57.6715729,7 58.5,7 Z",
    id: "Rectangle-Copy-99",
    fill: "#BBBBBD"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/Container.d2fd3ea676256b1729593a703490a9bf.svg";
export { ForwardRef as ReactComponent };